<h2 class="flex items-center gap-2 px-6 pt-4 text-2xl">
  <mat-icon>lock</mat-icon>
  Change Password
</h2>
<mat-dialog-content class="max-w-md">
  @if (isSubmitting$ | async) {
    <div
      class="absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-white/70"
    >
      <mat-progress-spinner
        mode="indeterminate"
        color="primary"
        diameter="50"
      ></mat-progress-spinner>
    </div>
  }
  <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-2">
    <div class="flex w-full flex-row">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Current password</mat-label>
        <input
          matInput
          [type]="hideOld ? 'password' : 'text'"
          formControlName="oldPassword"
          autocomplete="current-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideOld = !hideOld"
        >
          <mat-icon>{{ hideOld ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        @if (form.controls.oldPassword.invalid) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
    </div>
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>New password</mat-label>
      <input
        matInput
        [type]="hideNew ? 'password' : 'text'"
        formControlName="newPassword"
        autocomplete="new-password"
        aria-describedby="pw-req"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hideNew = !hideNew"
      >
        <mat-icon>{{ hideNew ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
      <mat-hint>Follow the requirements below</mat-hint>
      @if (form.controls.newPassword.hasError('required')) {
        <mat-error>Required</mat-error>
      }
    </mat-form-field>

    <div id="pw-req" class="rounded-xl bg-gray-50 p-3" aria-live="polite">
      <div class="mb-1 font-medium">Password requirements</div>
      <ul class="space-y-1 text-xs">
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.length"
            [class.text-gray-400]="!req.length"
            >check_circle</mat-icon
          >
          At least 8 characters
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.lower"
            [class.text-gray-400]="!req.lower"
            >check_circle</mat-icon
          >
          A lowercase letter
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.upper"
            [class.text-gray-400]="!req.upper"
            >check_circle</mat-icon
          >
          An uppercase letter
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.number"
            [class.text-gray-400]="!req.number"
            >check_circle</mat-icon
          >
          A number
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.symbol"
            [class.text-gray-400]="!req.symbol"
            >check_circle</mat-icon
          >
          A symbol
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class]="
              req.noUsernamePart && form.controls.newPassword.value.length > 3
                ? 'text-green-600'
                : 'text-gray-400'
            "
          >
            check_circle</mat-icon
          >
          No parts of your username
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class]="
              req.noFirstName && form.controls.newPassword.value.length > 3
                ? 'text-green-600'
                : 'text-gray-400'
            "
            >check_circle</mat-icon
          >
          Does not include your first name
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class]="
              req.noLastName && form.controls.newPassword.value.length > 3
                ? 'text-green-600'
                : 'text-gray-400'
            "
            >check_circle</mat-icon
          >
          Does not include your last name
        </li>
        <li
          class="border-gray-2 mt-2 flex gap-2 border-t-2 pt-2 italic text-blue-400"
        >
          <mat-icon class="!w-6 text-blue-400">info</mat-icon>
          <div class="flex flex-col">
            Can’t match your last 4 passwords
            <span>(checked on save)</span>
          </div>
        </li>
      </ul>
    </div>

    <!-- Confirm field stays below -->
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Confirm new password</mat-label>
      <input
        matInput
        [type]="hideConf ? 'password' : 'text'"
        formControlName="confirm"
        autocomplete="new-password"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hideConf = !hideConf"
      >
        <mat-icon>{{ hideConf ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
      @if (form.hasError('mismatch')) {
        <mat-error>Passwords don’t match</mat-error>
      }
    </mat-form-field>

    @if (errorMessage) {
      <mat-error class="mt-2 block">{{ errorMessage }}</mat-error>
    }

    <mat-dialog-actions>
      <div class="flex w-full justify-end gap-2">
        <button
          class="flex items-center rounded-xl bg-gray-100 px-4 py-2 shadow-sm hover:bg-gray-300"
          mat-dialog-close
        >
          Cancel
        </button>
        <button
          class="flex items-center rounded-xl bg-cobalt-500 px-4 py-2 text-white shadow-sm hover:bg-cobalt-400 disabled:cursor-not-allowed disabled:bg-gray-400 disabled:hover:bg-gray-400"
          type="submit"
          [disabled]="(isSubmitting$ | async) || form.invalid"
        >
          {{ (isSubmitting$ | async) ? 'Saving…' : 'Change password' }}
        </button>
      </div>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
